var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalander(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40169 0.76123V4.09456M11.0684 0.76123V4.09456M7.73503 11.5946H11.0684M1.06836 8.26123H14.4017M4.40169 11.5946H4.48503M2.73503 15.7612H12.735C13.6555 15.7612 14.4017 15.015 14.4017 14.0946V4.09456C14.4017 3.17409 13.6555 2.4279 12.735 2.4279H2.73503C1.81455 2.4279 1.06836 3.17409 1.06836 4.09456V14.0946C1.06836 15.015 1.81455 15.7612 2.73503 15.7612Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalander);
export default __webpack_public_path__ + "static/media/calander.b3543e136232c9a9c60af0d4ef17f9dc.svg";
export { ForwardRef as ReactComponent };